import { FiChevronRight } from 'react-icons/fi';
import { NavLink } from 'react-router-dom';

import { useVhAdminAccess } from '@/admin/useVhAdminAccess.ts';
import IconVhSettings from '@/assets/icon-vh-settings.svg?react';
import { SplitLayout } from '@/components';

import s from '../SettingsPage.module.scss';

import {
  renderSettingsSection,
  type SettingsSection,
  type SettingsSectionDef,
} from './settings-sections';

export function SettingsLayout({
  sections,
  active,
  onChange,
  open,
}: {
  sections: readonly SettingsSectionDef[];
  active: SettingsSection;
  onChange: (value: SettingsSection, params?: Record<string, string>) => void;
  /** `?tab=` names a section — folded, the list gives way to it. Back is the header's. */
  open: boolean;
}) {
  const canVHAdmin = useVhAdminAccess();

  return (
    <SplitLayout
      className={s.layout}
      open={open}
      sectionKey={active}
      aside={
        <aside className={s.sidebar}>
          {sections.length === 0 && (
            <div className={s.empty}>No settings match. Please try a different search.</div>
          )}
          {sections.map((sec) => (
            <button
              key={sec.value}
              type="button"
              className={`${s.navItem} ${active === sec.value ? s.navItemActive : ''}`}
              onClick={() => onChange(sec.value)}
            >
              <div className={s.navIcon}>
                <sec.icon />
              </div>
              <div className={s.navText}>
                <div className={s.navTitle}>{sec.label}</div>
                <div className={s.navSub}>{sec.sub}</div>
              </div>
              <FiChevronRight className={s.navChevron} />
            </button>
          ))}

          {canVHAdmin === 'allowed' && (
            <>
              <hr className={s.hr} />
              <NavLink to="/vh-admin" aria-label="VH Admin" className={s.navItem}>
                <div className={s.navIcon}>
                  <IconVhSettings className={s.vhAdmIco} />
                </div>
                <div className={s.navText}>
                  <div className={s.navTitle}>Administration</div>
                  <div className={s.navSub}>System settings.</div>
                </div>
              </NavLink>
            </>
          )}
        </aside>
      }
    >
      <div className={s.detail}>{renderSettingsSection(sections, active)}</div>
    </SplitLayout>
  );
}
